import { createContext, useContext } from "react";

import { APIService, CookieService } from "@client/services";
import {
	AuthStore,
	LayoutStore,
	ModalStore,
	PrintStore,
	VendorStore,
} from "@client/stores";
import { ConfigStore } from "@client/stores/config-store/config-store";

export class RootContext {
	apiService: APIService;
	cookieService: CookieService;

	configStore: ConfigStore;
	modalStore: ModalStore;
	layoutStore: LayoutStore;
	printStore: PrintStore;

	vendorStore: VendorStore;
	authStore: AuthStore;

	constructor() {
		this.apiService = new APIService();
		this.cookieService = new CookieService(this);

		this.configStore = new ConfigStore(this);
		this.modalStore = new ModalStore(this);
		this.layoutStore = new LayoutStore(this);
		this.printStore = new PrintStore(this);

		this.vendorStore = new VendorStore(this);
		this.authStore = new AuthStore(this);
	}
}

export const rootContext = new RootContext();
const context = createContext(rootContext);

export const useRootContext = () => useContext(context);

export default RootContext;
